/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Ig_UnavailableInputs */

const cs_social_export_ig_unavailable = /** @type {(inputs: Social_Export_Ig_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram není na tomto účtu propojený.`)
};

const en_social_export_ig_unavailable = /** @type {(inputs: Social_Export_Ig_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram is not linked on this account.`)
};

/**
* | output |
* | --- |
* | "Instagram is not linked on this account." |
*
* @param {Social_Export_Ig_UnavailableInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_ig_unavailable = /** @type {((inputs?: Social_Export_Ig_UnavailableInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Ig_UnavailableInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_ig_unavailable(inputs)
	return cs_social_export_ig_unavailable(inputs)
});